import { render, staticRenderFns } from "./ContainerApellation.vue?vue&type=template&id=2cd44a62"
import script from "./ContainerApellation.vue?vue&type=script&lang=js"
export * from "./ContainerApellation.vue?vue&type=script&lang=js"
import style0 from "./ContainerApellation.vue?vue&type=style&index=0&id=2cd44a62&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports